import React from 'react';

import { Header } from '@/components/global/Header';
import { Title } from '@/components/global/Title';
import { Description } from '@/components/global/Description';
import { Slider } from '@/components/Template/Template3/Slider';
import { MoreInfo } from '@/components/global/MoreInfo';

import { TRecommendation } from '@/services/requests/Recommendation/types/template3';

type TProps = {
  data: TRecommendation;
};

export function Layout2({ data }: TProps) {
  return (
    <>
      <Header data={data.header} template="3" />
      <Title data={data} template="3" />
      <Description data={data} template="3" />
      <Slider data={data} />
      <MoreInfo data={data} template="3" />
    </>
  );
}
